import Axios from 'axios'
import { refreshInterceptor } from './apis'

export const ApiHCA = Axios.create({
    baseURL: process.env.REACT_APP_HCA_API,
})

ApiHCA.interceptors.response.use(
    ok => ok,
    error => refreshInterceptor(error, ApiHCA)
)

export const getMeetingTokens = (algorithm_id?: string | null) =>
    ApiHCA.post<GetTokensDTO>('/sdk_session/get_sdk_tokens', {
        algorithm_id: algorithm_id ?? undefined,
    }).then(({ data }) => data)

/**
 * HCA devuelve el objeto de la sala aunque todavía no tenga url asignada (ej. mesas sin generar):
 * manda `{ url: null }`, no omite la clave. Tipar `url` como no-nullable hacía que el fallback
 * `general_room ?? teams_room` de useOpenMeet fuera código muerto sin que TypeScript avisara.
 */
interface GetTokensDTO {
    general_room?: {
        token?: string
        url: string | null
    }
    teams_room?: {
        token?: string
        table_number: number
        url: string | null
    }
}
